import React from 'react';
import { Box, TextV2, ButtonV2, CloseButton } from '@withjoy/joykit';
import { useTranslation, useHistory } from '@shared/core';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { ArrowRight } from '@withjoy/joykit/icons';

interface AccommodationsVisibilityBannerProps
  extends Readonly<{
    onClose: () => void;
    eventHandle: string;
  }> {}

const AccommodationsVisibilityBanner: React.FC<AccommodationsVisibilityBannerProps> = ({ onClose, eventHandle }) => {
  const { tq } = useTranslation('publishReminder');
  const isMobile = useIsMobileScreen();
  const history = useHistory();

  const handleUpdateVisibility = useEventCallback(() => {
    // Build path directly without router helper to avoid context dependency
    const path = `/${eventHandle}/edit/accommodations?settings=true`;
    history.push(path);
    onClose();
  });

  return (
    <Box
      display="flex"
      backgroundColor="newUIBrandPrimary"
      width="100%"
      zIndex="banner"
      position="fixed"
      top={0}
      alignItems="center"
      justifyContent="center"
      paddingX={5}
      paddingY={5}
      gap={4}
    >
      <TextV2
        typographyVariant="body1"
        color="white"
      >
        {isMobile ? tq`Your 'Where to Stay' page is hidden from guests.` : tq`Your 'Where to Stay' page is hidden from guests. Enable it when you're ready to share.`}
      </TextV2>
      <ButtonV2
        flexShrink={0}
        variant="ghost"
        typographyVariant="body1"
        intent="primary"
        _hover={{ color: 'white' }}
        _active={{ color: 'white' }}
        height="fit-content"
        endIcon={<ArrowRight size={16} />}
        onClick={handleUpdateVisibility}
        color="white"
      >
        {isMobile ? tq`Update` : tq`Update Visibility`}
      </ButtonV2>
      <CloseButton
        position="absolute"
        color="white"
        right={{ _: -16, md: 6 }}
        onClick={onClose}
      />
    </Box>
  );
};

AccommodationsVisibilityBanner.displayName = 'AccommodationsVisibilityBanner';

export { AccommodationsVisibilityBanner };
